import styled from "styled-components";

interface ITableBar {
  children: React.ReactNode;
  label: string;
}
const TableBar = ({ children, label }: ITableBar) => {
  return (
    <SContainer>
      <SLabel>{label}</SLabel>
      {children}
    </SContainer>
  );
};
export default TableBar;
const SLabel = styled.div`
  color: var(--color-primary);
  margin-left: 24px;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: 0.01em;
`;
const SContainer = styled.div`
  width: 100%;
  background: linear-gradient(
    90deg,
    var(--color-primary-soft) 0%,
    rgba(60, 127, 236, 0.03) 100%
  );
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
